<template>
    <div>
        <div v-if="version === 'basic'">
            <BasicKeymap />
        </div>
        <div v-else-if="version === 'dhusor'">
            <DhusorKeymap />
        </div>
        <div v-else-if="version === 'shobdopata'">
            <ShobdopataKeymap />
        </div>
        <div v-else-if="version === 'shuvro'">
            <ShuvroKeymap />
        </div>
    </div>
</template>

<script>
import BasicKeymap from './BasicKeymap';
import DhusorKeymap from './DhusorKeymap';
import ShobdopataKeymap from './ShobdopataKeymap';
import ShuvroKeymap from './ShuvroKeymap';
export default {
    name: 'ConverterKeymap',
    components: { ShuvroKeymap, ShobdopataKeymap, DhusorKeymap, BasicKeymap },
    data () {
        return {
            version: 'basic'
        };
    },
    watch: {
        $route (to, from) {
            this.version = to.params.version;
        }
    },
    mounted () {
        this.version = this.$route.params.version;
    }
};
</script>
